﻿<template>
    <section class="mb-card">
        <div class="mb-card-body">
            <h3 class="mb-card-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                Guests
                <span class="mb-count">{{ $store.getters.get_Booking?.passengers?.length ?? 0 }}</span>
            </h3>

            <div class="bd-guests">
                <passenger
                    v-for="(pax, index) in $store.getters.get_Booking?.passengers"
                    :key="index"
                    :pax="pax"
                    :index="index"
                ></passenger>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./passengers.ts"></script>